const ENABLE_FUNCTIONS =
  process.env.REACT_APP_ENABLE_FUNCTIONS === "YES" ?? false;
export { ENABLE_FUNCTIONS };
